interface HighlightedPart {
    text: string;
    isMatch: boolean;
    start: number;
}

export const splitByMatches = (value: string, text: string): HighlightedPart[] => {
    const words = value.trim().split(/\s+/).filter(Boolean);
    if (!words.length) {
        return [{ text, isMatch: false, start: 0 }];
    }

    const longestFirstTerms = [...new Set([words.join(' '), ...words])].sort((a, b) => b.length - a.length);
    const pattern = longestFirstTerms.map((s) => s.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`)).join('|');
    const regex = new RegExp(`(${pattern})`, 'gi');
    let start = 0;

    return text
        .split(regex)
        .map((part, index) => {
            const highlightedPart = { text: part, isMatch: index % 2 === 1, start };
            start += part.length;
            return highlightedPart;
        })
        .filter((part) => part.text);
};
